<template>
  <div class="select-role-popup">
    <div class="popup-shadow" @click="hideSelectRolePopup"></div>
    <div class="popup-content">
      <div class="popup-container">
        <div class="popup-title">
          {{ letter.selectRoleName }}
          <span @click="handleGoLogOut" class="logout" v-if="!isInWebview">
            [ {{ letter.logout }} ]
          </span>
        </div>
        <role-select isPopup="true"></role-select>
        <div
          class="pre-store-info"
          v-show="
            lastedGame == gameId && lastedServerId && getCurLastedServerName
          "
        >
          <span
            >{{ letter.previousSelect }}：{{ getCurLastedServerName }} -
            {{ lastedRoleName }}</span
          >
          <span class="again-role j-again-role" @click="setLastedServerId"
            >{{ letter.payAgainBtn }}>></span
          >
        </div>
        <Icon
          class="popup-close"
          name="close"
          @click="hideSelectRolePopup"
        ></Icon>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import RoleSelect from '@components/officialTopup/login/RoleSelect.vue';
import login from '@mixins/officialTopup/login';
import { mapState } from 'vuex';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
export default {
  name: 'SelectRolePopup',
  mixins: [login],
  computed: {
    ...mapState({
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      lastedRoleName: state => state.lastedRoleName,
      lastedServerId: state => state.lastedServerId,
      lastedRoleId: state => state.lastedRoleId,
      lastedGame: state => state.lastedGame,
      loginAccount: state => state.login.loginAccount,
      letter: state => state.letter,
      isInWebview: state => state.isInWebview
    }),
    getCurLastedServerName() {
      let res = '';
      if (!this.serverList || this.lastedGame != this.gameId) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.lastedServerId) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    }
  },
  methods: {
    setLastedServerId() {
      clickButton({
        btnName: 'store_again',
        locationKey: locationType.charPopup
      });
      this.serverId = this.lastedServerId;
      this.roleId = this.lastedRoleId;
      this.loadRole();
    },
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.charPopup
      });
      this.goLogOut();
    }
  },
  components: {
    RoleSelect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
@import '@assets/scss/officialTopup/_dimen.scss';
.select-role-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.popup-content {
  width: $popupWidth;
}
.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  background: $backgroundColor;
  padding: 40px 42px;
}

.popup-title {
  text-align: left;
  font-size: 28px;
  font-weight: bold;
  margin: 0 40px 40px 0;
}

.logout {
  display: inline-block;
  color: #333;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
}

.popup-close {
  position: absolute;
  margin-top: -10px;
  top: 42px;
  right: 42px;
  width: 34px;
  height: 34px;
  cursor: pointer;
}

.pre-store-info {
  margin-top: 21px;
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #666666;
}
.select-wrap {
  ::v-deep .row-item {
    width: 100%;
  }
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
  }

  .popup-title {
    font-size: 22px;
  }

  .select-wrap {
    ::v-deep .row-item {
      font-size: 20px;
      width: 100%;
    }
  }

  .pre-store-info {
    font-size: 18px;
  }
}
</style>
